import {
  ADD_SPRINT_REQUEST,
  ADD_SPRINT_SUCCESS,
  ADD_SPRINT_FAIL,
  GET_SPRINTS_REQUEST,
  GET_SPRINTS_SUCCESS,
  GET_SPRINTS_FAIL,
  GET_SPRINT_TASKS_REQUEST,
  GET_SPRINT_TASKS_SUCCESS,
  GET_SPRINT_TASKS_FAIL,
  UPDATE_SPRINT_COMPLETE_STATUS,
  PUSH_SPRINT_TASKS_SUCCESS,
  PUSH_ARCHIVED_SPRINTS,
  RESET_ARCHIVED_SPRINTS,
} from "./sprintTypes";
import {
  ENTER_IN_ARCHIVE_TASK,
  REMOVED_TASK_SOCKET,
  EDITED_TASK_SOCKET,
  EDITED_TASK_DEPENDENCY_SOCKET,
  CHANGE_TASK_DATES_SUSSECCFULLY,
  OUT_OF_ARCHIVE_TASK,
  CHANGE_TASK_STATUS,
  SOCKET_CHANGE_BNB,
  NEW_TASK_SOCKET,
  NEW_CHECKLIST_TASK_ADD,
  GET_CHECKLIST_TASK,
  TASK_CHECKLIST_ORDER_CHANGED,
  TASK_CHECKLIST_DELETE,
  TASK_CHECKLIST_STATUS_CHANGED,
  NEW_TASK_CHANNEL_MESSAGE_SOCKET,
  REACT_BOARD_CHANNEL_MESSAGE,
  Delete_TASK_CHANNEL_MESSAGE_SOCKET,
  SET_TASK_EISENHOWER,
} from "../SocketTaskTypes";
import {
  PUSH_NEW_TASKS,
  GET_SINGLE_TASK_SUCCESS,
  GET_TASK_MEMBER_SUCCESS,
} from "../Task/taskTypes";
import {
  RENAMED_TASK_SECCESS,
  CHANGED_TASK_VALUE,
  CHANGED_TASK_COMPLETE_STATUS,
  GET_TASKDESC_SUCCESS,
} from "../Task/taskDescTypes";
import {
  REPLACE_VOICE_DESC_IN_TASK,
  GET_TASK_TEMPORARY_GOALS,
  UPDATE_TASK_TASKDETAIL_GANTT,
} from "../Misc/miscTypes";
import {
  GET_BOARD_TASK_CHANNEL_MESSAGES,
  TASK_CHANNEL_LOAD_OLDER_SUCCESS,
  EDIT_TASK_MESSAGE,
} from "../Channel/channelTypes";
import { GET_TASK_CHARTER } from "../Charter/CharterType";
import { GET_TASK_DOCUMENTS } from "../Documentation/DocumentationType";
import { GET_TASK_MEETING_MINUTES } from "../MeetingMinutes/MeetingMinutesType";
import { GET_TASK_CORRESPONDENCE } from "../Correspondence/CorrespondenceType";
import {
  GET_TASK_RESOURCES,
  GET_TASK_RESOURCES_BUYLIST,
} from "../Resources/ResourcesType";

const initialState = {
  sprints: [],
  loading: false,
  error: null,
};

export const sprintReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SPRINTS_REQUEST:
    case ADD_SPRINT_REQUEST:
      return { ...state, loading: true };

    case GET_SPRINTS_SUCCESS:
      // این حالت برای دریافت کل لیست است و درست است
      return {
        loading: false,
        sprints: action.payload, // لیست کامل از سرور
        error: null,
      };

    case ADD_SPRINT_SUCCESS:
      // این حالت برای افزودن یک اسپرینت جدید به لیست موجود است
      return {
        ...state, // سایر خصوصیات state (مثل loading, error) را حفظ کن
        loading: false, // بارگذاری تمام شده
        // لیست موجود اسپرینت‌ها را بردار، اسپرینت جدید را به انتهای آن اضافه کن
        sprints: [...state.sprints, action.payload],
        error: null,
      };

    case GET_SPRINTS_FAIL:
    case ADD_SPRINT_FAIL:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_SPRINT_COMPLETE_STATUS: {
      const { SprintID, Complete, TeamRate } = action.payload;
      return {
        ...state,
        sprints: state.sprints.map((s) =>
          s._id === SprintID
            ? { ...s, Complete, ...(TeamRate != null && { TeamRate }) }
            : s,
        ),
      };
    }

    default:
      return state;
  }
};
// export const sprintReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case GET_SPRINTS_REQUEST:
//     case ADD_SPRINT_REQUEST:
//       return { ...state, loading: true };

//     case GET_SPRINTS_SUCCESS:
//     case ADD_SPRINT_SUCCESS:
//       return {
//         loading: false,
//         sprints: action.payload, // لیست جدید جایگزین لیست قبلی می‌شود
//         error: null,
//       };

//     case GET_SPRINTS_FAIL:
//     case ADD_SPRINT_FAIL:
//       return { ...state, loading: false, error: action.payload };

//     default:
//       return state;
//   }
// };
const sprintTasksInitialState = {
  tasks: [],
  loading: false,
  error: null,
};

/**
 * Applies `updater` to the sprint task with the given id.
 * Returns the new tasks array, or null when the task is not in the sprint list
 * (callers should then leave state untouched).
 */
const patchSprintTaskById = (tasks, taskId, updater) => {
  const idx = tasks.findIndex((t) => String(t._id) === String(taskId));
  if (idx === -1) return null;
  const next = [...tasks];
  next[idx] = updater(next[idx]);
  return next;
};

/**
 * Task-detail actions (fired from TaskDetail or sockets) only carry a TaskID
 * plus the changed field — mirrored here from TasksStateReducer so sprint-tab
 * tasks stay in sync too. Keyed by action type → payload-to-field mapper.
 */
const SPRINT_TASK_FIELD_PATCHES = {
  [GET_TASK_CHARTER]: (p) => ({ Charter: p.Charter }),
  [GET_TASK_DOCUMENTS]: (p) => ({ Documents: p.Documents }),
  [GET_TASK_MEETING_MINUTES]: (p) => ({ MeetingMinutes: p.MeetingMinutes }),
  [GET_TASK_CORRESPONDENCE]: (p) => ({ Correspondences: p.Correspondences }),
  [GET_TASK_TEMPORARY_GOALS]: (p) => ({ TemporaryGoals: p.data }),
  [GET_TASK_MEMBER_SUCCESS]: (p) => ({ TaskMembers: p.data }),
  [GET_TASK_RESOURCES]: (p) => ({ TaskResources: p.Resources }),
  [GET_TASK_RESOURCES_BUYLIST]: (p) => ({
    TaskResourcesBuyLists: p.ResourcesBuyLists,
  }),
  [UPDATE_TASK_TASKDETAIL_GANTT]: (p) => ({
    Start: p.body?.Start,
    End: p.body?.End,
  }),
  [SET_TASK_EISENHOWER]: (p) => ({ Eisenhower: p.Eisenhower }),
};

export const sprintTasksReducer = (state = sprintTasksInitialState, action) => {
  const sprintFieldPatch = SPRINT_TASK_FIELD_PATCHES[action.type];
  if (sprintFieldPatch && action.Payload?.TaskID != null) {
    const patch = sprintFieldPatch(action.Payload);
    const patched = patchSprintTaskById(
      state.tasks,
      action.Payload.TaskID,
      (t) => ({ ...t, ...patch }),
    );
    return patched ? { ...state, tasks: patched } : state;
  }

  switch (action.type) {
    case GET_SPRINT_TASKS_REQUEST:
      return { ...state, loading: true };
    case GET_SPRINT_TASKS_SUCCESS:
      return { loading: false, tasks: action.payload || [], error: null };

    case PUSH_SPRINT_TASKS_SUCCESS: {
      const tasks = [...state.tasks, ...action.Payload];
      // const unique = [...new Set(tasks)];

      const unique = tasks.filter(
        (task, index, self) =>
          index === self.findIndex((t) => t._id === task._id),
      );

      return {
        ...state,
        loading: false,
        tasks: unique,
      };
    }
    case GET_SPRINT_TASKS_FAIL:
      return { loading: false, tasks: [], error: action.payload };
    case ENTER_IN_ARCHIVE_TASK: {
      const id = action.Payload?._id;
      if (!id) return state;
      return {
        ...state,
        tasks: state.tasks.filter((task) => String(task._id) !== String(id)),
      };
    }
    case REMOVED_TASK_SOCKET: {
      const id = action.Payload;
      if (id == null) return state;
      return {
        ...state,
        tasks: state.tasks.filter((task) => String(task._id) !== String(id)),
      };
    }
    case OUT_OF_ARCHIVE_TASK: {
      const task = action.Payload;
      if (!task?._id) return state;
      const exists = state.tasks.some(
        (t) => String(t._id) === String(task._id),
      );
      if (exists) {
        return {
          ...state,
          tasks: state.tasks.map((t) =>
            String(t._id) === String(task._id) ? { ...t, ...task } : t,
          ),
        };
      }
      return { ...state, tasks: [...state.tasks, task] };
    }

    case EDITED_TASK_SOCKET: {
      const payload = action.Payload;
      if (!payload?._id) return state;
      const idx = state.tasks.findIndex(
        (t) => String(t._id) === String(payload._id),
      );
      if (idx === -1) return state;
      const prev = state.tasks[idx];
      const nextTask = {
        ...payload,
        Open: prev?.Open,
        Creator:
          payload.Creator !== undefined ? payload.Creator : prev?.Creator,
      };
      const nextTasks = [...state.tasks];
      nextTasks[idx] = nextTask;
      return { ...state, tasks: nextTasks };
    }

    case EDITED_TASK_DEPENDENCY_SOCKET: {
      const { TaskID, Dependency } = action.Payload || {};
      if (!TaskID) return state;
      const idx = state.tasks.findIndex(
        (t) => String(t._id) === String(TaskID),
      );
      if (idx === -1) return state;
      const nextTasks = [...state.tasks];
      nextTasks[idx] = { ...nextTasks[idx], Dependency };
      return { ...state, tasks: nextTasks };
    }

    case CHANGE_TASK_DATES_SUSSECCFULLY: {
      const payload = action.Payload;
      if (!payload?._id) return state;
      const idx = state.tasks.findIndex(
        (t) => String(t._id) === String(payload._id),
      );
      if (idx === -1) return state;
      const nextTasks = [...state.tasks];
      const row = { ...nextTasks[idx] };
      if (payload.Loop !== undefined) {
        row.Loop = payload.Loop;
        row.LoopTimeData = payload.LoopTimeData ?? {};
        row.Start = undefined;
        row.End = undefined;
      } else {
        row.Start = payload.Start;
        row.End = payload.End;
        if (payload.ManuallyTimeDuration !== undefined) {
          row.ManuallyTimeDuration = payload.ManuallyTimeDuration;
        }
      }
      nextTasks[idx] = row;
      return { ...state, tasks: nextTasks };
    }

    case CHANGE_TASK_STATUS: {
      const payload = action.Payload || {};
      const { TaskID, Status, data: taskData } = payload;
      if (!TaskID) return state;
      const idx = state.tasks.findIndex(
        (t) => String(t._id) === String(TaskID),
      );
      if (idx === -1) return state;
      const current = state.tasks[idx];
      let nextRow = current;
      if (taskData && typeof taskData === "object") {
        nextRow = {
          ...current,
          ...taskData,
          Status: Status ?? taskData.Status ?? current.Status,
        };
      } else {
        const nextStatus = Status ?? current.Status;
        nextRow = {
          ...current,
          Status: nextStatus,
          ...(nextStatus === "Complete" ? { Complete: true } : {}),
        };
      }
      const nextTasks = [...state.tasks];
      nextTasks[idx] = nextRow;
      return { ...state, tasks: nextTasks };
    }

    case CHANGED_TASK_COMPLETE_STATUS: {
      const { TaskID, Complete } = action.Payload || {};
      if (!TaskID) return state;
      const idx = state.tasks.findIndex(
        (t) => String(t._id) === String(TaskID),
      );
      if (idx === -1) return state;
      const nextTasks = [...state.tasks];
      nextTasks[idx] = { ...nextTasks[idx], Complete };
      return { ...state, tasks: nextTasks };
    }

    case SOCKET_CHANGE_BNB: {
      const updates = action.Payload;
      if (!Array.isArray(updates) || updates.length === 0) return state;
      let nextTasks = [...state.tasks];
      for (let i = 0; i < updates.length; i++) {
        const u = updates[i];
        if (!u?._id) continue;
        const idx = nextTasks.findIndex((t) => String(t._id) === String(u._id));
        if (idx === -1) continue;
        const row = { ...nextTasks[idx] };
        if (u.Column !== undefined) row.Column = u.Column;
        if (u.ColumnID !== undefined) row.ColumnID = u.ColumnID;
        if (u.SprintID !== undefined) row.SprintID = u.SprintID;
        if (u.Priority !== undefined) row.Priority = u.Priority;
        if (u.TableListPriority !== undefined)
          row.TableListPriority = u.TableListPriority;
        if (u.SprintPriority !== undefined)
          row.SprintPriority = u.SprintPriority;
        nextTasks[idx] = row;
      }
      return { ...state, tasks: nextTasks };
    }

    case RENAMED_TASK_SECCESS: {
      const { _id, TaskName } = action.Payload || {};
      if (!_id) return state;
      const idx = state.tasks.findIndex((t) => String(t._id) === String(_id));
      if (idx === -1) return state;
      const nextTasks = [...state.tasks];
      nextTasks[idx] = { ...nextTasks[idx], TaskName };
      return { ...state, tasks: nextTasks };
    }

    case CHANGED_TASK_VALUE: {
      const { TaskID, TaskValue } = action.Payload || {};
      if (!TaskID) return state;
      const idx = state.tasks.findIndex(
        (t) => String(t._id) === String(TaskID),
      );
      if (idx === -1) return state;
      const nextTasks = [...state.tasks];
      nextTasks[idx] = { ...nextTasks[idx], TaskValue };
      return { ...state, tasks: nextTasks };
    }

    case REPLACE_VOICE_DESC_IN_TASK: {
      const taskId = action.Payload?.TaskID;
      if (!taskId) return state;
      const idx = state.tasks.findIndex(
        (t) => String(t._id) === String(taskId),
      );
      if (idx === -1) return state;
      const p = action.Payload;
      const nextTasks = [...state.tasks];
      const row = { ...nextTasks[idx] };
      if (p.VoiceDesc !== undefined) row.VoiceDesc = p.VoiceDesc;
      if (p.VoiceDescUrls !== undefined) row.VoiceDescUrls = p.VoiceDescUrls;
      if (p.VoiceDescs !== undefined) row.VoiceDescs = p.VoiceDescs;
      if (p.VideoDescs !== undefined) row.VideoDescs = p.VideoDescs;
      nextTasks[idx] = row;
      return { ...state, tasks: nextTasks };
    }

    case NEW_TASK_SOCKET: {
      const task = action.Payload;
      if (!task?._id) return state;
      if (state.tasks.some((t) => String(t._id) === String(task._id))) {
        return {
          ...state,
          tasks: state.tasks.map((t) =>
            String(t._id) === String(task._id) ? { ...t, ...task } : t,
          ),
        };
      }
      return { ...state, tasks: [...state.tasks, task] };
    }

    case PUSH_NEW_TASKS: {
      const incoming = action.Payload;
      if (!Array.isArray(incoming) || incoming.length === 0) return state;
      const existingIds = new Set(state.tasks.map((t) => String(t._id)));
      const newOnes = incoming.filter(
        (task) => task?._id && !existingIds.has(String(task._id)),
      );
      if (newOnes.length === 0) return state;
      return { ...state, tasks: [...state.tasks, ...newOnes] };
    }

    case GET_SINGLE_TASK_SUCCESS: {
      const payload = action.Payload;
      const taskToUpdate = Array.isArray(payload)
        ? payload.find((t) => t?._id)
        : payload;
      if (!taskToUpdate?._id) return state;
      const patched = patchSprintTaskById(
        state.tasks,
        taskToUpdate._id,
        (t) => ({ ...t, ...taskToUpdate }),
      );
      if (patched) return { ...state, tasks: patched };
      // Sprint task not loaded yet (e.g. pagination) — insert it.
      if (taskToUpdate.SprintID) {
        return { ...state, tasks: [...state.tasks, taskToUpdate] };
      }
      return state;
    }

    case GET_TASKDESC_SUCCESS: {
      const patched = patchSprintTaskById(state.tasks, action.TaskID, (t) => ({
        ...t,
        Desc: action.Payload,
      }));
      return patched ? { ...state, tasks: patched } : state;
    }

    case NEW_CHECKLIST_TASK_ADD: {
      const patched = patchSprintTaskById(
        state.tasks,
        action.Payload?.TaskID,
        (t) => ({
          ...t,
          TaskChecklist: [...(t.TaskChecklist || []), action.Payload.body],
        }),
      );
      return patched ? { ...state, tasks: patched } : state;
    }

    case GET_CHECKLIST_TASK:
    case TASK_CHECKLIST_ORDER_CHANGED:
    case TASK_CHECKLIST_DELETE:
    case TASK_CHECKLIST_STATUS_CHANGED: {
      const patched = patchSprintTaskById(
        state.tasks,
        action.Payload?.TaskID,
        (t) => ({ ...t, TaskChecklist: action.Payload.body }),
      );
      return patched ? { ...state, tasks: patched } : state;
    }

    case NEW_TASK_CHANNEL_MESSAGE_SOCKET: {
      const payloadData = action.Payload?.data;
      const taskID = action.Payload?.TaskID;
      if (!taskID) return state;
      const patched = patchSprintTaskById(state.tasks, taskID, (t) => {
        const chat = t.TaskChat || [];
        if (payloadData?._replaceTempId) {
          const idx = chat.findIndex(
            (m) => String(m._id) === String(payloadData._replaceTempId),
          );
          if (idx === -1) return t;
          const clean = { ...payloadData };
          delete clean._replaceTempId;
          const next = [...chat];
          next[idx] = clean;
          return { ...t, TaskChat: next };
        }
        if (payloadData?._markFailedId) {
          return {
            ...t,
            TaskChat: chat.map((m) =>
              String(m._id) === String(payloadData._markFailedId)
                ? {
                    ...m,
                    _status: "failed",
                    _errorMessage: payloadData._errorMessage,
                  }
                : m,
            ),
          };
        }
        return { ...t, TaskChat: [...chat, payloadData] };
      });
      return patched ? { ...state, tasks: patched } : state;
    }

    case REACT_BOARD_CHANNEL_MESSAGE: {
      const { MessageID, TaskID, reactions } = action.Payload ?? {};
      if (!TaskID) return state;
      const patched = patchSprintTaskById(state.tasks, TaskID, (t) => ({
        ...t,
        TaskChat: (t.TaskChat || []).map((m) =>
          String(m._id) === String(MessageID)
            ? { ...m, Reactions: reactions }
            : m,
        ),
      }));
      return patched ? { ...state, tasks: patched } : state;
    }

    case GET_BOARD_TASK_CHANNEL_MESSAGES: {
      const patched = patchSprintTaskById(
        state.tasks,
        action.Payload?.TaskID,
        (t) => ({ ...t, TaskChat: action.Payload.data }),
      );
      return patched ? { ...state, tasks: patched } : state;
    }

    case TASK_CHANNEL_LOAD_OLDER_SUCCESS: {
      const { TaskID, data: olderMessages } = action.Payload ?? {};
      const patched = patchSprintTaskById(state.tasks, TaskID, (t) => {
        const existing = t.TaskChat ?? [];
        const existingIds = new Set(existing.map((m) => String(m._id)));
        const deduped = (olderMessages ?? []).filter(
          (m) => !existingIds.has(String(m._id)),
        );
        return { ...t, TaskChat: [...deduped, ...existing] };
      });
      return patched ? { ...state, tasks: patched } : state;
    }

    case Delete_TASK_CHANNEL_MESSAGE_SOCKET: {
      const patched = patchSprintTaskById(
        state.tasks,
        action.Payload?.TaskID,
        (t) => ({
          ...t,
          TaskChat: (t.TaskChat || []).filter(
            (m) => m._id !== action.Payload.body,
          ),
        }),
      );
      return patched ? { ...state, tasks: patched } : state;
    }

    case EDIT_TASK_MESSAGE: {
      const patched = patchSprintTaskById(
        state.tasks,
        action.Payload?.TaskID,
        (t) => ({
          ...t,
          TaskChat: (t.TaskChat || []).map((m) =>
            m._id === action.Payload.body?._id ? action.Payload.body : m,
          ),
        }),
      );
      return patched ? { ...state, tasks: patched } : state;
    }

    default:
      return state;
  }
};
// export const sprintsArchivedReducer = (
//   state = { ArchivedSprints: [] },
//   action
// ) => {
//   switch (action.type) {
//     case GET_SPRINTS_ARCHIVED_REQUEST: {
//       return { ...state, ArchivedSprints: [] };
//     }
//     case GET_SPRINTS_ARCHIVED_SUCCESS: {
//       return { ...state, ArchivedSprints: action.payload };
//     }
//     case ENTER_IN_ARCHIVE_SPRINTS: {
//       return {
//         ...state,
//         ArchivedSprints: [...state.ArchivedSprints, action.payload],
//       };
//     }
//     case OUT_OF_ARCHIVE_SPRINTS: {
//       let arr = state.ArchivedSprints;
//       arr = arr.filter((item) => item._id !== action.payload._id);

//       return {
//         ...state,
//         ArchivedSprints: arr,
//       };
//     }
//     default: {
//       return state;
//     }
//   }
// };

export const archivedSprintsReducer = (
  state = { sprints: [], hasMore: true, queryKey: null },
  action,
) => {
  switch (action.type) {
    case RESET_ARCHIVED_SPRINTS: {
      const { sprints, hasMore, queryKey } = action.payload || {};
      return {
        sprints: sprints || [],
        hasMore: hasMore ?? false,
        queryKey: queryKey ?? null,
      };
    }
    case PUSH_ARCHIVED_SPRINTS: {
      const { sprints: incoming, hasMore, queryKey } = action.payload || {};
      if (
        queryKey != null &&
        state.queryKey != null &&
        queryKey !== state.queryKey
      ) {
        return state;
      }
      const existingIds = new Set(state.sprints.map((s) => s._id?.toString()));
      const newOnes = (incoming || []).filter(
        (s) => !existingIds.has(s._id?.toString()),
      );
      return {
        ...state,
        sprints: [...state.sprints, ...newOnes],
        hasMore: hasMore ?? false,
      };
    }
    default:
      return state;
  }
};
